import { NavLink } from 'react-router-dom';
import AdminLayout from '../../layout/AdminLayout';
import DatePicker from 'react-datepicker';

import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useDidMountEffect from '../../hooks/useDidMountEffect';

// 헬퍼 함수: 무조건 YYYY-MM 문자열만 반환
const getYearMonth = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

export default function IncentiveCurrent() {
  const [incentiveList, setIncentiveList] = useState([]);
  const [lvList, setLvList] = useState([]);
  const today = new Date();

  const [startDate, setStartDate] = useState(today);

  // 초기값부터 YYYY-MM으로 설정
  const [search, setSearch] = useState({
    searchMonth: getYearMonth(today),
    viewType: 'M',
    lv: ''
  });

  const getIncentiveList = () => {
    Server.sendGet('shopify/sales/incentive', search, getIncentiveListCallback).then();
  }

  const getIncentiveListCallback = res => {
    setIncentiveList(res?.['resultList'] || []);
  }

  const getSalesLvList = () => {
    Server.sendGet('shopify/sales/lv', {}, getSalesLvListCallback).then();
  }

  const getSalesLvListCallback = res => {
    setLvList(res?.['resultList'] || []);
  }

  const openOrgWindow = salesPersonId => {
    window.open(`/admin/incentiveorg?salesPersonId=${salesPersonId}&viewType=${search.viewType}&searchMonth=${search.searchMonth}`, 'popupWindow', 'width=1573, height=900');
  }

  const changeDateType = value => {
    setStartDate(today);
    setSearch((prev) => ({
      ...prev,
      viewType: value,
      searchMonth: getYearMonth(today), // YYYY-MM
    }));
  };

  const changeStartDate = date => {
    setStartDate(date);
    setSearch((prev) => ({
      ...prev,
      searchMonth: getYearMonth(date), // YYYY-MM
    }));
  };

  const changeLv = value => {
    setSearch((prev) => ({
      ...prev,
      lv: value === '' ? '' : value
    }));
  }

  useEffect(() => {
    getSalesLvList();
    getIncentiveList();
  }, []);

  useDidMountEffect(() => {
    getIncentiveList();
  }, [search]);

  return (
    <AdminLayout>
      <div className='title'>
        <div className='tit-head'>
          <i />
          <h4>Incentive</h4>
        </div>
      </div>
      <div className="util-menu">
        <div className="menu-in">
          <div className="item-in">
            <select id="level-sel" name="level-sel" onChange={e => changeLv(e.target.value)}>
              <option value=''>- Lv -</option>
              {lvList?.map((item, idx) => (
                <option key={idx} value={item.lv}>{item.lv}</option>
              ))}
            </select>
          </div>
          <CateIn>
            <Cate>
              <CateSel
                value={search?.viewType}
                onChange={e => changeDateType(e.target.value)}
              >
                <option value={'M'}>Monthly</option>
                <option value={'Y'}>Yearly</option>
              </CateSel>
            </Cate>
          </CateIn>
          <div className='item-in'>
            <DatePicker
              selected={startDate}
              dateFormat={search.viewType === 'M' ? 'yyyy-MM' : 'yyyy'}
              onChange={date => changeStartDate(date)}
              showMonthYearPicker={search.viewType === 'M'}
              showYearPicker={search.viewType === 'Y'}
            />
          </div>
        </div>
      </div>
      <div className="content">
        <table className="admin-table">
          <thead>
          <tr>
            <th>Member Name</th>
            <th>Referral ID</th>
            <th>Personal Sales (PS)</th>
            <th>Total DownLine Sales (DS)</th>
            <th>Estimated Commission (PS)</th>
            <th>Estimated Commission (PS + DS)</th>
            <th>View DownLine</th>
          </tr>
          </thead>
          <tbody>
          {incentiveList?.map((item, idx) => (
            <tr key={idx}>
              <td>{item.salesPersonName}</td>
              <td>{item.upReferralId}</td>
              <td>{Number(item.selfSales || 0).toLocaleString()}</td>
              <td>{Number(item.downLineTotalSales || 0).toLocaleString()}</td>
              <td>{Number(item.selfIncentive || 0).toLocaleString()}</td>
              <td>{Number(item.estimatedIncentive || 0).toLocaleString()}</td>
              <td>
                <Btn onClick={() => openOrgWindow(item.salesPersonId)}>View</Btn>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}

const Btn = styled.button`
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
  border-radius: 5px;
  background: #0072b9;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  border: none;
  cursor: pointer;
`;

const CateIn = styled.div` display: flex; align-items: center; gap: 0 20px; `;
const Cate = styled.div` display: flex; align-items: center; gap: 0 10px; `;
const CateSel = styled.select`
  width: 150px;
  height: 40px;
  padding: 0 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;
